import PropTypes from 'prop-types';

clusterStyle.propTypes = {
  /** Style function for single features. */
  featureStyle: PropTypes.func.isRequired,
  /** Style function for clusters. */
  clusterStyle: PropTypes.func.isRequired
};

/**
 * Styles a clustered layer with separate styles for clusters and features.
 * @component
 */
export default function clusterStyle(_ref) {
  var featureStyle = _ref.featureStyle,
      clusterStyle = _ref.clusterStyle;

  return function (cluster, resolution) {
    var features = cluster.get('features');
    if (features.length === 0) return;
    if (features.length === 1) return featureStyle(features[0], resolution);
    return clusterStyle(cluster, resolution);
  };
}